import { Dashboard } from '@ih/app/shared/apis/interfaces';

export class DeleteDashboardSuccess {
  public static readonly type =
    '[Project/Dashboard/List] DeleteDashboardSuccess';
  constructor(public readonly dashboard: Dashboard) {}
}
